import { useCallback } from 'react';
import useVideoContext from '../useVideoContext/useVideoContext';

export function useKrispToggle() {
  useVideoContext();
  const toggleKrisp = useCallback(() => {}, []);
  return { vendor: undefined, toggleKrisp };
}
